import React from 'react';
import createSvgIcon from '../createNewIcon.js';
const CheckboxCheck = createSvgIcon(React.createElement(React.Fragment, null,
    React.createElement("polygon", { points: "10,17.432 4.586,12.018 6,10.604 10,14.604 18,6.604 19.414,8.018 " })), 'CheckboxCheck');
export default CheckboxCheck;
